import { groupStatusDictionary } from "@medoma/models/visits";
import {
  activityOccurrenceStatusSchema,
  activityOccurrenceStatusDictionary,
  groupStatusSchema,
} from "@medoma/models/activities";
import z from "zod";

const _statusSchema = z.union([
  activityOccurrenceStatusSchema,
  groupStatusSchema,
]);
export type IStatus = z.infer<typeof _statusSchema>;

export const statusDictionary = {
  ...activityOccurrenceStatusDictionary,
  ...groupStatusDictionary,
};
